import React from "react";
import Component from '@reach/component-component'
import Swiper from 'swiper'
import Link from 'gatsby-link'
import newsData from "../../whats-new-content";
import defaultImage from "../../images/ati_logo.jpg"
import { createHtmlText } from '../../helpers'

class NewsSwiper extends React.Component {
    state = {
        maxSwipes: null
      };

    constructor({ maxSwipesCount }) {
        super();
        this.state.maxSwipes = maxSwipesCount;
      }

    renderImage = (article) =>{
      if (article != null && article.hero != null){
        return article.hero;
      }else{
        return defaultImage;
      }
    }

    renderAdvertisement = (article) =>{
      return (
          <img src={article.data.image} alt="" style={{ margin: "auto", width: 870, height: 375}}/>
      );      
    }

    getAdLinkLocation = article => {
      if (article != null && article.link != null) {
        return article.link.location;
      } else {
        return "";
      }
    };
  
    getAdLink = article => {
      if (article != null && article.link != null) {
        if (article.link.target === "blank") {
          return (
            <a href={this.getAdLinkLocation(article)} target="_blank">
              {this.renderAdvertisement(article)}
            </a>
          );
        } else {
          return (
            <a href={this.getAdLinkLocation(article)}>
              {this.renderAdvertisement(article)}
            </a>
          );
        }
      }
  
      return "";
    };

    renderArticle = (article) =>{
      if (article != null) {
        if (article.data.type != "ad") {
          return (
          <div className="event-section__content">
            <div className="event-section__img min-tablet" >
            <img src={this.renderImage(article)} alt=""  style={{ height: 480}}/>
            </div>
            <div className="event-section__text">
              <h1 className="t-h2">{article.title}</h1>
              <p className="t-p mt20" dangerouslySetInnerHTML={createHtmlText(article.intro)}/>
              <Link to={"/articles?id=" + article.id} className="c-btn t-link mt30">Learn More</Link>
            </div>      
          </div>
          );
        } else {
          return (
            <div className="event-section__content">
              <div className="event-section__img min-tablet" >
                {this.getAdLink(article)}
              </div>
            </div>
          )
        }
      }
    }

    renderNews = () => {
        var articles = newsData.slice(0,this.state.maxSwipes).map((article, articleKey) => (
          <div className="swiper-slide">
            {this.renderArticle(article)}
          </div>
        ));
        return <div className="swiper-wrapper" style={{ alignItems: "center", paddingBottom: "50px"}}>{articles}</div>;
      };

    render() {
      return (
        <section className="event-section t-context--light" style={{ paddingTop: "50px", paddingBottom: "30px" }}>
          <Component
            refs={{ slider: null }}
            didMount={({ refs }) => {
              refs.swiper = new Swiper('.event-slider', {
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                  500: {
                    navigation: {
                      nextEl: null,
                      prevEl: null,
                    },
                  },
                },
              })
            }}
            willUnmount={({ refs }) => {
              refs.swiper.destroy()
            }}
          >
            {({ refs }) => (
              <div
                className="swiper-container event-slider"
                ref={ref => (refs.slider = ref)}
              >
                {this.renderNews()}
                <div className="swiper-pagination" />
                <div className="swiper-button-next" />
                <div className="swiper-button-prev" />
              </div>
            )}
          </Component>
        </section>
      );
    }
    
}
export default NewsSwiper;


// WEBPACK FOOTER //
// ./src/components/News/NewsSwiper.js